@if (locationValidModal) {
  <div class="modal-header">
    <h4 class="modal-title">Location Validation</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
      >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Please select the location from voucher Info page for particular variant
      to enable it
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="activeModal.close('Close click')"
      >
      Close
    </button>
  </div>
}

@if (successModal) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup">Successfully saved!</div>
  <div class="modal-body-popup">
    <p>Voucher has been saved. Do u want to make voucher as Active?​</p>
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="voucherActivePage($event)"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="voucherActivePage($event)"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (statusConfirmationModal) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup">
    <p>{{ statusConfirmationModalObj.message }}</p>
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="activeModal.close('no')"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="activeModal.close('yes')"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (successModalVariant) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup">Successfully saved!</div>
  <div class="modal-body-popup">
    <p>
      Voucher has been saved. Kindly choose the status of drafted/newly added
      variants from below.​
    </p>
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="variantActivePage($event)"
        >
        Deactive
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="variantActivePage($event)"
        >
        Active
      </button>
    </div>
  </div>
}

@if (successUpdateModal) {
  <div
    style="
      display: flex;
      flex-direction: row-reverse;
      margin: 10px 20px 0px 0px;
    "
    >
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
      >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup" style="padding-bottom: 30px">
    Successfully updated file!
  </div>
}

@if (apiResponseModal) {
  <div class="modal-header-popup">
    @if (responseStructure?.success) {
      <img
        class="logo-chevron"
        src="assets/images/circle-check.png"
        />
    }
    @if (!responseStructure?.success) {
      <img
        class="logo-chevron"
        src="assets\images\img_error.png"
        />
    }
  </div>
  @if (responseStructure?.success) {
    <div class="modal-title-popup">
      Successful!
    </div>
  }
  @if (!responseStructure?.success) {
    <div class="modal-title-popup">
      Failed!
    </div>
  }
  <div class="modal-body-popup">
    <p>
      {{ responseStructure?.message }}
    </p>
  </div>
  <div class="footer-align-popup">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark"
        (click)="activeModal.close('Close click')"
        >
        OK
      </button>
    </div>
  </div>
}

@if (createVoucherModal) {
  <div class="modal-header-popup"></div>
  <div class="create-voucher-heading">
    <img class="main-icon" src="assets/images/CreateVoucherIcon.png" />
    <div class="modal-title-popup heading-popup">Create Voucher</div>
  </div>
  <div class="modal-body-popup body-popup">
    <p>Do you want to create voucher with variant?​</p>
  </div>
  <div class="footer-align-popup">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn button-style-no"
        (click)="withoutVariant($event)"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn button-style"
        (click)="withVariant($event)"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (statusModal) {
  <div class="modal-header-popup"></div>
  <div class="create-voucher-heading">
    <img class="main-icon" src="assets/images/CreateVoucherIcon.png" />
    <div class="modal-title-popup heading-popup">Voucher Status</div>
    <button
      type="button"
      class="close cross-icon"
      aria-label="Close"
      (click)="activeModal.dismiss()"
      >
      <span aria-hidden="true">x</span>
    </button>
  </div>
  <div class="modal-body-popup body-popup">
    <p>You are about to change the status. Kindly choose the option below</p>
  </div>
  <div class="footer-align-popup">
    @if (eventStatus == 'INACTIVE') {
      <div class="modal-footer-popup">
        <button
          type="button"
          class="btn button-width"
          (click)="reactivate($event)"
          [ngbTooltip]="tipActive"
          >
          Re-Active
        </button>
      </div>
    }
    @if (
      eventStatus == 'ACTIVE' ||
      (eventStatus == 'INACTIVE' && eventActive == true)
      ) {
      <div
        class="modal-footer-popup"
        >
        <button
          type="button"
          class="btn button-width"
          (click)="totalDeactivate($event)"
          [ngbTooltip]="tipTotal"
          >
          Total Deactivate
        </button>
      </div>
    }
    @if (
      eventStatus == 'ACTIVE' ||
      (eventStatus == 'INACTIVE' && eventActive == false)
      ) {
      <div
        class="modal-footer-popup"
        >
        <button
          type="button"
          class="btn button-width"
          (click)="partialDeactivate($event)"
          [ngbTooltip]="tipPartial"
          >
          Partial Activate
        </button>
      </div>
    }
    @if (eventStatus == 'DRAFT') {
      <div class="modal-footer-popup">
        <button
          type="button"
          class="btn button-width"
          (click)="reactivate($event)"
          [ngbTooltip]="tipActive"
          >
          Active
        </button>
      </div>
    }
    @if (eventStatus == 'DRAFT') {
      <div class="modal-footer-popup">
        <button
          type="button"
          class="btn button-width"
          (click)="totalDeactivate($event)"
          [ngbTooltip]="tipTotal"
          >
          Deactive
        </button>
      </div>
    }
  </div>
}

@if (salesBundleModal) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup">Successfully saved!</div>
  <div class="modal-body-popup">
    <p>Sales Bundle has been saved. Do u want to make it as Active?​</p>
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="bundleDetailPage()"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="bundleActivePage($event)"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (errorModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/img_error.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup error-body">
    <p>{{ error }}​</p>
  </div>
}

@if (deleteVoucherModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup">
    <p>{{ deleteResponse }}​</p>
  </div>
}

@if (deleteVoucherConfirmationModal) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup">
    @if (variantId) {
      <p>Do you want to delete variant?</p>
    }
    @if (!variantId) {
      <p>Do you want to delete voucher?</p>
    }
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="noDelete()"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="deleteDeactiveVoucher()"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (tierModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/img_error.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup error-body">
    <p>Please select tier</p>
  </div>
}

@if (tierVariantModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/img_error.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup error-body">
    <p>Please select variant tier</p>
  </div>
}

@if (dataUpdateModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/img_error.png" />
  </div>
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup error-body">
    <p>Data updated! Reselect voucher for data updation.</p>
  </div>
}

@if (campaignSuccessModal) {
  <div class="modal-header-popup">
    <img class="logo-chevron" src="assets/images/circle-check.png" />
  </div>
  <div class="modal-title-popup">Successfully saved!</div>
  <div class="modal-body-popup">
    <p>Campaign has been saved. Do u want to make campaign Active?​</p>
  </div>
  <div class="footer-align-popup button-align">
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="campaignDrafted()"
        >
        No
      </button>
    </div>
    <div class="modal-footer-popup">
      <button
        type="button"
        class="btn btn-outline-dark button-style"
        (click)="campaignActivated()"
        >
        Yes
      </button>
    </div>
  </div>
}

@if (expiryDateExtendModal) {
  <div class="close-modal" (click)="closeModal()">X</div>
  <div class="modal-header-date">Request to Extend Expiry Date</div>
  <hr />
  <div class="modal-title-popup"></div>
  <div class="modal-body-popup error-body">
    <div class="flex-container input-data">
      <div class="flex-column1-input">
        <div class="form-floating">
          <input
            type="text"
            class="form-control addinput disabled"
            id="voucherTitle"
            placeholder="Voucher Title"
            value="{{ transactionDetail?.name }}"
            disabled
            />
            <label for="voucherTitle" class="addLabel">Voucher Title</label>
          </div>
          <div class="form-floating">
            <input
              type="text"
              class="form-control addinput disabled"
              id="enrichId"
              placeholder="Enrich ID"
              value="{{ transactionDetail?.enrichId }}"
              disabled
              />
              <label for="voucherTitle" class="addLabel">Enrich ID</label>
            </div>
            <div class="form-floating remarks-div">
              <input
                type="text"
                class="form-control addinput"
                id="remarks"
                placeholder="Remarks"
                [(ngModel)]="remarks"
                />
                <label for="voucherTitle" class="addLabel">Remarks</label>
              </div>
              <div class="parent-button">
                <div class="button-next">
                  <button
                    type="button"
                    class="btn btn-primary mx-2 button-class"
                    (click)="cancel()"
                    >
                    Back
                  </button>
                </div>
                <div class="button-next">
                  <button
                    type="submit"
                    class="btn btn-primary mx-2 button-class"
                    (click)="saveExpiryDate()"
                    >
                    Save
                  </button>
                </div>
              </div>
            </div>
            <div class="flex-column2-input">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control addinput disabled"
                  id="oExpiryDate"
                  placeholder="Original Expiry Date"
            value="{{ transactionDetail?.expiryDate | date: 'dd/MM/yyyy' }} {{
              transactionDetail?.expiryDate | date: 'HH:mm:ss'
            }}"
                  disabled
                  />
                  <label for="voucherTitle" class="addLabel">
                    Original Expiry Date
                  </label>
                </div>
                <div class="form-floating">
                  <input
                    type="datetime-local"
                    class="form-control addinput"
                    id="nExpiryDate"
                    placeholder="New Expiry Date"
                    (change)="passDate($event)"
                    />
                    <label for="voucherTitle" class="addLabel">New Expiry Date</label>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (changeOwnerModal) {
            <div class="close-modal" (click)="closeModal()">X</div>
            <div class="modal-header-date">Request to Change Owner</div>
            <hr />
            <div class="modal-title-popup"></div>
            <div class="modal-body-popup error-body">
              <div class="flex-container input-data">
                <div class="flex-column1-input">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control addinput disabled"
                      id="voucherTitle"
                      placeholder="Voucher Title"
                      value="{{ transactionDetail?.name }}"
                      disabled
                      />
                      <label for="voucherTitle" class="addLabel">Voucher Title</label>
                    </div>
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control addinput disabled"
                        id="cEnrichId"
                        placeholder="Current Enrich ID"
                        value="{{ transactionDetail?.enrichId }}"
                        disabled
                        />
                        <label for="voucherTitle" class="addLabel">Current Enrich ID</label>
                      </div>
                      <div class="parent-button">
                        <div class="button-next">
                          <button
                            type="button"
                            class="btn btn-primary mx-2 button-class"
                            (click)="cancel()"
                            >
                            Back
                          </button>
                        </div>
                        <div class="button-next">
                          <button
                            type="submit"
                            class="btn btn-primary mx-2 button-class"
                            (click)="saveOwnerDetail()"
                            >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="flex-column2-input">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control addinput"
                          id="nEnrichId"
                          placeholder="New Enrich ID"
                          [(ngModel)]="newEnrichId"
                          />
                          <label for="voucherTitle" class="addLabel">New Enrich ID</label>
                        </div>
                        <div class="form-floating remarks-div">
                          <input
                            type="text"
                            class="form-control addinput"
                            id="remarks"
                            placeholder="Remarks"
                            [(ngModel)]="remarks"
                            />
                            <label for="voucherTitle" class="addLabel">Remarks</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if (changeStatus) {
                    <div class="modal-header-popup">
                      <img class="logo-chevron" src="assets/images/circle-check.png" />
                    </div>
                    <div class="modal-title-popup">Successfully changed!</div>
                    <div class="modal-body-popup">
                      <p>Status has been changed from Used to Redeemed</p>
                    </div>
                    <div class="footer-align-popup button-align">
                      <div class="modal-footer-popup">
                        <button
                          type="button"
                          class="btn btn-outline-dark button-style"
                          (click)="statusChanged()"
                          >
                          Ok
                        </button>
                      </div>
                    </div>
                  }

                  @if (deleteModal) {
                    <div class="modal-header-popup">
                      <img class="logo-chevron" src="assets/images/circle-check.png" />
                    </div>
                    <div class="modal-title-popup"></div>
                    <div class="modal-body-popup">
                      <p>Do you want to delete transaction?</p>
                    </div>
                    <div class="footer-align-popup button-align">
                      <div class="modal-footer-popup">
                        <button
                          type="button"
                          class="btn btn-outline-dark button-style"
                          (click)="noDelete()"
                          >
                          No
                        </button>
                      </div>
                      <div class="modal-footer-popup">
                        <button
                          type="button"
                          class="btn btn-outline-dark button-style"
                          (click)="delete(id)"
                          >
                          Yes
                        </button>
                      </div>
                    </div>
                  }

                  @if (cancelTransactionModal) {
                    <div class="close-modal" (click)="closeModal()">X</div>
                    <div class="modal-header-date">Request to Cancel Transaction</div>
                    <hr />
                    <div class="modal-title-popup"></div>
                    <div class="modal-body-popup error-body">
                      <div class="flex-container input-data">
                        <form [formGroup]="cancelTransactionForm" (ngSubmit)="submit()">
                          <div class="flex-column1-input">
                            <div class="form-floating remarks-div">
                              <input
                                type="text"
                                class="form-control addinput"
                                id="remarks"
                                placeholder="Remarks"
                                formControlName="remarks"
                                required
                                />
                                <label for="voucherTitle" class="addLabel">Remarks</label>
                                @if (cancelTransactionError()) {
                                  <div
                                    class="cancelTransactionError"
                                    >
                                    <small class="campaign-error"> Please add remarks </small>
                                  </div>
                                }
                              </div>
                              <div class="parent-button">
                                <div class="button-next">
                                  <button
                                    type="button"
                                    class="btn btn-primary mx-2 button-class"
                                    (click)="cancel()"
                                    >
                                    Back
                                  </button>
                                </div>
                                <div class="button-next">
                                  <button
                                    type="submit"
                                    class="btn btn-primary mx-2 button-class"
                                    (click)="cancelTransaction()"
                                    >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    }

                    @if (transactionSuccessModal) {
                      <div class="close-modal" (click)="closeModal()">X</div>
                      <div class="modal-header-popup">
                        <img class="logo-chevron" src="assets/images/circle-check.png" />
                      </div>
                      <div class="modal-title-popup"></div>
                      <div class="modal-body-popup">
                        <p>
                          {{ transactionSuccessMsg }}
                        </p>
                      </div>
                    }

                    @if (transactionConfirmationModal) {
                      <div class="modal-header-popup">
                        <img class="logo-chevron" src="assets/images/circle-check.png" />
                      </div>
                      <div class="modal-title-popup">
                        <p>
                          {{ transactionConfirmationMsg }}
                        </p>
                      </div>
                      <div class="footer-align-popup">
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="closeModal()"
                            >
                            Decline
                          </button>
                        </div>
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="transactionConfirmationPopUp()"
                            >
                            Ok
                          </button>
                        </div>
                      </div>
                    }

                    @if (expiryDateModal) {
                      <div class="modal-header">
                        <h4 class="modal-title">Expiry Date Updation</h4>
                        <button
                          type="button"
                          class="close"
                          aria-label="Close"
                          (click)="activeModal.dismiss()"
                          >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <p>Do you want to update expiry date in registry?</p>
                      </div>
                      <div class="footer-align-popup">
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="closeModal()"
                            >
                            No
                          </button>
                        </div>
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="updateExpiryDate($event, index)"
                            >
                            Yes
                          </button>
                        </div>
                      </div>
                    }

                    @if (selectCampaign) {
                      <div class="modal-header-popup"></div>
                      <div class="create-voucher-heading">
                        <div class="modal-title-popup heading-popup">Select campaign</div>
                      </div>
                      <div class="modal-body-popup body-popup">
                        <hr />
                        <form [formGroup]="campaignForm" (ngSubmit)="submit()">
                          <select
                            formControlName="campaign"
                            class="form-select form-control adddropdown"
                            >
                            <option value="" disabled selected>Campaign title*</option>
                            @for (item of campaignList; track item) {
                              <option value="{{ item.id }}">
                                {{ item.name }}
                              </option>
                            }
                          </select>
                          @if (campaignForm.invalid && campaignFormSubmitted) {
                            <div
                              class="campaignDropdownError"
                              >
                              <small class="campaign-error"> Please select a campaign </small>
                            </div>
                          }
                          <button
                            type="button"
                            class="btn button-style-no campaignBtnCancel"
                            (click)="closeModal()"
                            >
                            Cancel
                          </button>
                          <button type="submit" class="btn button-style">Ok</button>
                        </form>
                      </div>
                    }

                    @if (deleteCampaignConfirmationModal) {
                      <div class="modal-header-popup">
                        <img class="logo-chevron" src="assets/images/circle-check.png" />
                      </div>
                      <div class="modal-title-popup"></div>
                      <div class="modal-body-popup">
                        <p>Do you want to delete Campaign?</p>
                      </div>
                      <div class="footer-align-popup button-align">
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="cancel()"
                            >
                            No
                          </button>
                        </div>
                        <div class="modal-footer-popup">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="deleteCampaign()"
                            >
                            Yes
                          </button>
                        </div>
                      </div>
                    }

                    @if (catalogueOverride) {
                      <div class="modal-header-popup">
                        <img class="logo-chevron" src="assets/images/circle-check.png" />
                      </div>
                      <div class="modal-title-popup"></div>
                      <div class="modal-body-popup">
                        <p>
                          This action will override all voucher redemption settings for
                          <span style="font-weight: 600">{{
                            catalogueOverrideObj.catalogueMerchentType
                          }}</span>
                          in
                          <span style="font-weight: 600">{{
                            catalogueOverrideObj.catalogueCountry
                            }}</span
                            >.
                          </p>
                          <p>Are you sure you want to continue</p>
                        </div>
                        <div class="footer-align-popup button-align">
                          <div class="modal-footer-popup">
                            <button
                              type="button"
                              class="btn btn-outline-dark button-style"
                              (click)="cancel()"
                              >
                              No
                            </button>
                          </div>
                          <div class="modal-footer-popup">
                            <button
                              type="button"
                              class="btn btn-outline-dark button-style"
                              (click)="activeModal.close('yes')"
                              >
                              Yes
                            </button>
                          </div>
                        </div>
                      }

                      @if (campaignStatusModal) {
                        <div class="modal-header-popup"></div>
                        <div class="create-voucher-heading">
                          <img class="main-icon" src="assets/images/CreateVoucherIcon.png" />
                          <div class="modal-title-popup heading-popup">{{campaignVoucherTitle ? campaignVoucherTitle : 'Campaign Status'}}</div>
                          <button
                            type="button"
                            class="close cross-icon"
                            aria-label="Close"
                            (click)="activeModal.dismiss()"
                            >
                            <span aria-hidden="true">x</span>
                          </button>
                        </div>
                        <div class="modal-body-popup body-popup">
                          <p>You are about to change the status. Kindly choose the option below</p>
                        </div>
                        <div class="footer-align-popup">
                          @if (eventStatus == 'INACTIVE') {
                            <div class="modal-footer-popup">
                              <button
                                type="button"
                                class="btn button-width"
                                (click)="updateCampaignStatus($event, 'active')"
                                [ngbTooltip]="tipActive"
                                >
                                Re-Active
                              </button>
                            </div>
                          }
                          @if (
                            eventStatus == 'ACTIVE' ||
                            (eventStatus == 'INACTIVE' && eventActive == true)
                            ) {
                            <div
                              class="modal-footer-popup"
                              >
                              <button
                                type="button"
                                class="btn button-width"
                                (click)="updateCampaignStatus($event, 'inactive')"
                                [ngbTooltip]="tipTotal"
                                >
                                Total Deactivate
                              </button>
                            </div>
                          }
                          @if (
                            eventStatus == 'ACTIVE' ||
                            (eventStatus == 'INACTIVE' && eventActive == false)
                            ) {
                            <div
                              class="modal-footer-popup"
                              >
                              <button
                                type="button"
                                class="btn button-width"
                                (click)="updateCampaignStatus($event, 'partial')"
                                [ngbTooltip]="tipPartial"
                                >
                                Partial Activate
                              </button>
                            </div>
                          }
                        </div>
                      }

                      @if (updateCatalogueFlag) {
                        <div class="modal-header-popup">
                          <img class="logo-chevron" src="assets/images/circle-check.png" />
                        </div>
                        <div class="modal-body-popup">
                          <p>Please confirm your changes!​</p>
                        </div>
                        <div class="footer-align-popup button-align">
                          <div class="modal-footer-popup">
                            <button
                              type="button"
                              class="btn btn-outline-dark button-style"
                              (click)="activeModal.close('no')"
                              >
                              No
                            </button>
                          </div>
                          <div class="modal-footer-popup">
                            <button
                              type="button"
                              class="btn btn-outline-dark button-style"
                              (click)="activeModal.close('yes')"
                              >
                              Yes
                            </button>
                          </div>
                        </div>
                      }

                      @if (campaignVoucherBulkStatusFail) {
                        <div class="modal-header-popup">
                          <img class="logo-chevron" src="assets/images/circle-check.png" />
                        </div>
                        <div class="modal-title-popup"></div>
                        <div class="modal-body-popup">
                          <p>Selected Vouchers are should have same status. Please unselect below vouchers to update status.</p>
                          <ul style="padding: 0 !important">
                            @for (id of voucherIDList; track id; let i = $index) {
                              <li style="list-style: none;">
                                <span>{{i + 1}}.Voucher Id - <b>{{id}}</b></span>
                              </li>
                            }
                          </ul>
                        </div>
                        <div class="campaign-modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="activeModal.close('yes')"
                            >
                            Okay
                          </button>
                        </div>
                      }

                      @if (campaignVoucherBulkValidErr) {
                        <div class="modal-header-popup">
                          <img class="logo-chevron" src="assets/images/circle-check.png" />
                        </div>
                        <div class="modal-title-popup"></div>
                        <div class="modal-body-popup">
                          <p>Please select vouchers to update status.</p>
                        </div>
                        <div class="campaign-modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="activeModal.close('yes')"
                            >
                            Close
                          </button>
                        </div>
                      }

                      @if (activityLogModal) {
                        <div class="modal-header-popup">
                          <img class="logo-chevron" src="assets/images/circle-check.png" />
                        </div>
                        <div class="modal-title-popup">Log Description</div>
                        <div class="modal-body-popup logs-container">
                          <p class="logs-paragraph">{{activityLogDescription}}</p>
                        </div>
                        <div class="campaign-modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-dark button-style"
                            (click)="activeModal.close('yes')"
                            >
                            Close
                          </button>
                        </div>
                      }
